import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ProductsApi } from '../../../../../core/api/products/products-api.service';
import { DashboardService } from '../../../../../core/services/dashboard.service';
import { ProductSelectComponent } from '../../../shared/components/product-select/product-select.component';

@Component({
  selector: 'app-dashboard-product-select',
  templateUrl: './dashboard-product-select.component.html',
  styleUrl: './dashboard-product-select.component.scss',
})
export class DashboardProductSelectComponent
  extends ProductSelectComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('barcodeInput', { read: ElementRef<HTMLInputElement> }) barcodeInput!: ElementRef<HTMLInputElement>;

  @Input() hideNotInStock = true;

  constructor(
    private dialogRef: MatDialogRef<unknown>,
    service: DashboardService,
    productsApi: ProductsApi
  ) {
    super(productsApi, service);
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngAfterViewInit(): void {
    this.dialogRef.afterOpened().subscribe(() => {
      setTimeout(() => {
        this.selectBarcodeInput();
      });
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }
}
